import WEBAPI from '../../services/WEBAPI.js';
import * as ATypes from '../../shared/actionTypes';
import { getDerivedAuthority } from '../authoritySelection/utilities';

export const getReports = () => {
  return (dispatch, getState) => {
    dispatch({
      type: ATypes.GET_MY_REPORTS_REQ,
    });

    return WEBAPI.getReports().then((res) => {
      dispatch({
        type: ATypes.GET_MY_REPORTS_RES,
        payload: res['result'],
      });
    });
  };
};

export const getSingleReport = (reportId, authName) => {
  return (dispatch, getState) => {
    const state = getState();
    const authorityName = authName || getDerivedAuthority(state);

    dispatch({
      type: ATypes.GET_SINGLE_REPORT_REQUEST,
    });

    return WEBAPI.getReports(authorityName, reportId)
      .then((res) => {
        const reportData = Array.isArray(res?.result?.data)
          ? res.result.data[0]
          : res?.result?.data;

        dispatch({
          type: ATypes.GET_SINGLE_REPORT_SUCCESS,
          payload: reportData || null,
        });

        return reportData;
      })
      .catch((error) => {
        dispatch({
          type: ATypes.GET_SINGLE_REPORT_FAILURE,
          error,
        });
      });
  };
};

export const getMoreReports = (nextUrl) => {
  return (dispatch) => {
    dispatch({
      type: ATypes.GET_MORE_REPORTS_REQ,
    });

    return WEBAPI.getMoreReports(nextUrl).then((res) => {
      dispatch({
        type: ATypes.GET_MORE_REPORTS_RES,
        payload: res?.result,
      });
    });
  };
};

const postRateReportLoading = (isLoading) => ({
  type: ATypes.POST_RATE_REPORT_LOADING,
  payload: isLoading,
});

const postRateReportSuccess = (response) => ({
  type: ATypes.POST_RATE_REPORT_SUCCESS,
  payload: response,
});

const postRateReportFailure = (error) => ({
  type: ATypes.POST_RATE_REPORT_ERROR,
  payload: error,
});

export const postRateReport =
  (authName, reportId, rating) => async (dispatch, getState) => {
    const state = getState();
    const authorityName = authName || getDerivedAuthority(state);

    dispatch(postRateReportLoading(true));

    try {
      const requestPayload = {
        authority_name: authorityName,
        action_type: 'rate',
        meta: {
          rate_value: rating,
        },
      };

      const response = await WEBAPI.postRateReportRequest(
        authorityName,
        requestPayload,
        reportId
      );

      if (response?.error) {
        throw new Error('Failed to rate report. Try again later.');
      }

      dispatch(postRateReportSuccess(response));
      await dispatch(getSingleReport(reportId, authorityName));
      return response;
    } catch (error) {
      dispatch(postRateReportFailure(error));
      throw error;
    } finally {
      dispatch(postRateReportLoading(false));
    }
  };
